import { useState } from "react";
import api from "../../../api";

export default function Admindelete() {
  const [chapterId, setChapterId] = useState("");
  const [subchapterNumber, setSubchapterNumber] = useState("");
  const [imageNumber,setImageNumber]=useState("");
  const [deleteType, setDeleteType] = useState("IMAGE"); // Default type
  const [message, setMessage] = useState("");

  const handleDelete = async () => {
    if (!chapterId || !subchapterNumber || !imageNumber) {
      setMessage("⚠️ Please enter both Chapter Number and Subchapter Number.");
      return;
    }

    try {
      let endpoint = "";

      if (deleteType === "IMAGE") {
        endpoint = `/admins/subchapter/image/${chapterId}/${subchapterNumber}/1`; 
        // assuming "1" for imageNumber if only one image exists for that subchapter
      } else if (deleteType === "IMAGE_WITH_HOTSPOTS") {
        endpoint = `/admins/subchapter/image-with-hotspots/${chapterId}/${subchapterNumber}/${imageNumber}`;
      }

      const response = await api.delete(endpoint);
      setMessage(response.data);
    } catch (error) {
      if (error.response) {
        setMessage(`❌ ${error.response.data.message || error.response.data}`);
      } else {
        setMessage("❌ Error deleting image.");
      }
    }
  };

  return (
    <div className="container d-flex justify-content-center align-items-center mt-5">
      <div className="card shadow-lg p-4" style={{ maxWidth: "500px", width: "100%" }}>
        <h2 className="card-title text-center text-danger mb-4">
          <i className="fas fa-trash-alt me-2"></i> Delete Subchapter Hotspot Image
        </h2>

        {/* Chapter Number */}
        <div className="mb-3">
          <label htmlFor="chapterId" className="form-label fw-bold">
            Chapter Number
          </label>
          <input
            type="number"
            id="chapterId"
            placeholder="Enter Chapter Number"
            value={chapterId}
            onChange={(e) => setChapterId(e.target.value)}
            className="form-control"
          />
        </div>

        {/* Subchapter Number */}
        <div className="mb-3">
          <label htmlFor="subchapterNumber" className="form-label fw-bold">
            Subchapter Number
          </label>
          <input
            type="number"
            id="subchapterNumber"
            placeholder="Enter Subchapter Number"
            value={subchapterNumber}
            onChange={(e) => setSubchapterNumber(e.target.value)}
            className="form-control"
          /> <label htmlFor="subchapterNumber" className="form-label fw-bold">
            Image Number
          </label>
          <input type="number" id="imageNumber" placeholder="Enter image number"
          value={imageNumber}
          onChange={(e)=>{setImageNumber(e.target.value)
          
          }} className="form-control"/>
        </div>

        {/* Delete Type Dropdown */}
        <div className="mb-3">
          <label htmlFor="deleteType" className="form-label fw-bold">
            Delete Type
          </label>
          <select
            id="deleteType"
            value={deleteType}
            onChange={(e) => setDeleteType(e.target.value)}
            className="form-select"
          >
            <option value="IMAGE">Normal Image</option>
            <option value="IMAGE_WITH_HOTSPOTS">Image with Hotspots</option>
          </select>
        </div>

        {/* Delete Button */}
        <div className="d-grid">
          <button onClick={handleDelete} className="btn btn-danger btn-lg">
            <i className="fas fa-trash me-2"></i> Delete Image
          </button>
        </div>

        {/* Result Message */}
        {message && (
          <div className="alert alert-info text-center mt-4" role="alert">
            {message}
          </div>
        )}
      </div>
    </div>
  );
}
